import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Button, Chip, Stack } from '@mui/material';
import kitchenTips from '../../content/cleaning-tips/categories/kitchen.json';

const TipCard = ({ tip }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>{tip.title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {tip.description}
      </Typography>
      <Stack direction="row" spacing={1}>
        <Chip label={tip.difficulty} size="small" />
        <Chip label={tip.timeRequired} size="small" />
      </Stack>
    </CardContent>
    <Button size="small" sx={{ m: 1 }}>Read More</Button>
  </Card>
);

const TipsGrid = () => {
  const [tips, setTips] = useState([]);

  useEffect(() => {
    setTips(kitchenTips);
  }, []);

  return (
    <Grid container spacing={3}>
      {tips.map(tip => (
        <Grid item xs={12} sm={6} md={4} key={tip.id}>
          <TipCard tip={tip} />
        </Grid>
      ))}
    </Grid>
  );
};

export default TipsGrid;
